import React from "react";

import "./src/styles/globals.scss";
import type { GatsbyBrowser } from "gatsby";
import { AppToaster } from "./src/components/atoms/AppToaster/AppToaster";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) =>
  React.createElement(React.Fragment, null, element, React.createElement(AppToaster));
